import { FetchBannerApiData } from '../../../Shared/AttraxTs/Generic/FetchBannerPoolApiData';
import { debounce } from './HelperFunctions';

type Banner = {
    title: string;
    imageId: string;
};

type BannerImages = {
    mobileImageId: string | undefined;
    desktopImageId: string | undefined;
};

export const getBannerImages = async () => {
    await fetchAndDisplayBanners('DI-Hero_Homepage', '.page-homepage__banner-hero .banner-customhtml');
    await fetchAndDisplayBanners('DI-Job_Results_Hero', '.page-job-results__banner-hero .banner-customhtml');
};

const fetchAndDisplayBanners = async (dataIdentifier: string, bannerSelector: string) => {
    const processedBanners = await fetchBanners(dataIdentifier);
    if (processedBanners) {
        const selectedImageId = selectBannerImage(processedBanners);
        updateBannerElement(selectedImageId, bannerSelector);
    }
};

export const fetchBanners = async (dataIdentifier: string): Promise<Banner[] | undefined> => {
    const args = {
        displayCount: 2,
        dataIdentifier,
        includeCustomHTML: true,
    }
    try {
        const data = await FetchBannerApiData(args);
        if (data && data.banners) {
            const processedBanners: Banner[] = [];
            for (const banner of data.banners) {
                const { title, imageId } = banner as Banner;
                if (!title || !imageId) {
                    console.error('Missing title or imageId');
                    continue;
                }
                processedBanners.push({ title, imageId });
            }
            return processedBanners;
        }
    } catch (error) {
        console.error(error);
    }
};

export const selectBannerImage = (processedBanners: Banner[]): BannerImages => {
    const mobileBanner = processedBanners.find(banner => banner.title === 'mobile');
    const desktopBanner = processedBanners.find(banner => banner.title === 'desktop');
    return {
        mobileImageId: mobileBanner?.imageId,
        desktopImageId: desktopBanner?.imageId
    };
}

export const updateBannerElement = (bannerImages: BannerImages, bannerSelector: string): void => {
    const bannerElement = document.querySelector(bannerSelector) as HTMLElement | null;
    if (bannerElement) {
        const imageId = window.innerWidth < 991 ? bannerImages.mobileImageId : bannerImages.desktopImageId;
        if (imageId) {
            bannerElement.style.backgroundImage = `url('/img/${imageId}')`;
        }
        bannerElement.classList.add('banner-customhtml--active');
        updateOnResize(bannerImages, bannerSelector);
    }
}

export const updateOnResize = (bannerImages: BannerImages, bannerSelector: string): void => {
    let wasMobileView = window.innerWidth < 768;
    const debouncedResizeHandler = debounce(() => {
        const isMobileView = window.innerWidth < 768;
        if (isMobileView !== wasMobileView) {
            updateBannerElement(bannerImages, bannerSelector);
            wasMobileView = isMobileView;
        }
    }, 200);
    window.addEventListener('resize', debouncedResizeHandler);
}